import React, { useState } from 'react'
import { Modal, Button, Progress } from 'antd'
import { unHidePartner } from '../../../../../services/api/3dApi'
import { getPartnerErrorMessage } from '../../../helpers/partnerPermission'
import { ExclamationCircleOutlined, CheckCircleOutlined } from '@ant-design/icons'

const ActionUnhidePartner = ({ isOpen, closeModal, listSelected, partners }) => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [listSuccess, setListSuccess] = useState([])
    const [listError, setListError] = useState([])
    const [listProcessing, setListProcessing] = useState(partners.filter(item => listSelected.includes(item._id)))
    const [isDone, setIsDone] = useState(false)

    const _onChangeUnhidePartner = async (id) => {
        setLoading(true)
        try {
            const { data } = await unHidePartner(id)
            const { success, error } = data

            if (!success) {
                return { success: success, message: error }
            }
            return { success: success }

        } catch (e) {
            return { success: false, message: getPartnerErrorMessage(e, 'hiện lại') }
        } finally {
            setLoading(false)
        }
    }
    const _onSubmitChange = async () => {
        setIsDone(false) // reset
        setListSuccess([])
        setListError([])
        setListProcessing(listProcessing.map(item => {
            if (item.success) delete item.success
            if (item.error) delete item.error
            return item
        }))

        let processed = []

        await Promise.all(listProcessing.map(async item => {
            const response = await _onChangeUnhidePartner(item._id)
            
            const { success, message } = response

            if (!success) return processed.push({ ...item, error: message, processing: false })
            return processed.push({ ...item, success: true, processing: false })

        }))

        let newListSuccess = []
        let newListError = []

        processed.forEach(process => {
            if (process.success) {
                newListSuccess.push(process)
            } else if (process.error.length > 0) {
                newListError.push(process)
            }
        })

        setListSuccess(newListSuccess)
        setListError(newListError)
        setIsDone(true)
        return setListProcessing(processed)
    }
    
    return (
        <Modal
            className="BulkChangeUser"
            visible={isOpen}
            title="Hiện Partner"
            onOk={_onSubmitChange}
            onCancel={closeModal}
            footer={[
                <Button key="back" disabled={loading} onClick={closeModal}>
                    Cancel
                </Button>,
                <Button key="submit" disabled={loading || isDone} type="primary" loading={loading} onClick={_onSubmitChange}>
                    Save
                </Button>
            ]}
        >
            <div className="FormItem">
                {error && <span className='text-danger'>{error}</span>}
                <h6>List processing <span>{listSelected.length}</span> {listSelected.length > 1 ? 'partners' : 'partner'}</h6>
                {
                    (listSuccess.length > 0 || listError.length > 0) &&
                    <div className="Results d-flex align-items-center">
                        <div className="ResultSuccess mr-2">
                            Success: <span className='text-success font-weight-bold'>{listSuccess.length}</span> {listSuccess.length > 1 ? 'partners' : 'partner'}
                        </div>
                        <div className="ResultError">
                            Error: <span className='text-danger font-weight-bold'>{listError.length}</span> {listError.length > 1 ? 'partners' : 'partner'}
                        </div>
                    </div>
                }
                <div className="ListProcessing">
                    <ul>
                        {
                            !!listProcessing && listProcessing.length > 0 && listProcessing.map(item => (
                                <li key={item._id}>
                                    <span className='mr-2 font-weight-bold'>{item.name}</span>
                                    {
                                        !!item.error &&
                                        <span className="Error text-danger"><ExclamationCircleOutlined /> {item.error}</span>
                                    }
                                    {
                                        item.success &&
                                        <span className="Success text-success"><CheckCircleOutlined /> Hiện đối tác thành công</span>
                                    }
                                    <Progress
                                        percent={100}
                                        size="small"
                                        status={`${(item.processing === false && item.success === true) ? 'success' : ((item.processing === false && !!item.error) ? 'exception' : 'active')}`}
                                        showInfo={false}
                                    />
                                </li>
                            )
                            )
                        }
                    </ul>
                </div>
            </div>

        </Modal>
    )
}

export default ActionUnhidePartner